import { defineInjectable, Injectable, Inject, inject, NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatNativeDateModule } from '@angular/material';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// import { LoggerModule } from './logger.module';
// providedIn: LoggerModule
var LoggerService = /** @class */ (function () {
    function LoggerService() {
    }
    LoggerService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ LoggerService.ngInjectableDef = defineInjectable({ factory: function LoggerService_Factory() { return new LoggerService(); }, token: LoggerService, providedIn: "root" });
    return LoggerService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var UtilsConfigService = 'Utils Config';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var noop = (/**
 * @return {?}
 */
function () { return undefined; });
var ConsoleLoggerService = /** @class */ (function () {
    function ConsoleLoggerService(config) {
        this.config = config;
        if (this.config.isDebugMode) {
            console.log('Console Logger Service registered');
        }
    }
    Object.defineProperty(ConsoleLoggerService.prototype, "info", {
        get: /**
         * @return {?}
         */
        function () {
            if (this.config.isDebugMode) {
                return console.info.bind(console);
            }
            else {
                return noop;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConsoleLoggerService.prototype, "warn", {
        get: /**
         * @return {?}
         */
        function () {
            if (this.config.isDebugMode) {
                return console.warn.bind(console);
            }
            else {
                return noop;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConsoleLoggerService.prototype, "error", {
        get: /**
         * @return {?}
         */
        function () {
            if (this.config.isDebugMode) {
                return console.error.bind(console);
            }
            else {
                return noop;
            }
        },
        enumerable: true,
        configurable: true
    });
    ConsoleLoggerService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ConsoleLoggerService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [UtilsConfigService,] }] }
    ]; };
    /** @nocollapse */ ConsoleLoggerService.ngInjectableDef = defineInjectable({ factory: function ConsoleLoggerService_Factory() { return new ConsoleLoggerService(inject("Utils Config")); }, token: ConsoleLoggerService, providedIn: "root" });
    return ConsoleLoggerService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StaticInjectorService = /** @class */ (function () {
    function StaticInjectorService(config) {
        this.config = config;
        if (this.config.isDebugMode) {
            console.log('Static Injector Service registered');
        }
    }
    /**
     * @param {?} injector
     * @return {?}
     */
    StaticInjectorService.setInjector = /**
     * @param {?} injector
     * @return {?}
     */
    function (injector) {
        StaticInjectorService.injector = injector;
    };
    /**
     * @return {?}
     */
    StaticInjectorService.getInjector = /**
     * @return {?}
     */
    function () {
        return StaticInjectorService.injector;
    };
    StaticInjectorService.injector = null;
    StaticInjectorService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    StaticInjectorService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [UtilsConfigService,] }] }
    ]; };
    /** @nocollapse */ StaticInjectorService.ngInjectableDef = defineInjectable({ factory: function StaticInjectorService_Factory() { return new StaticInjectorService(inject("Utils Config")); }, token: StaticInjectorService, providedIn: "root" });
    return StaticInjectorService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UtilsModule = /** @class */ (function () {
    function UtilsModule(staticInjector) {
        this.staticInjector = staticInjector;
        // I'm injecting the StaticInjectorService so that its constructor() will be called and the UtilsConfigService injected.
    }
    /**
     * @param {?} config
     * @return {?}
     */
    UtilsModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        // ng build --prod
        // ERROR in Error during template compile of 'CoreModule'
        // Function calls are not supported in decorators but 'UtilsModule' was called.
        // console.log('UtilsModule: forRoot()');
        // console.log(JSON.stringify(config));
        return {
            ngModule: UtilsModule,
            providers: [
                { provide: UtilsConfigService, useValue: config }
            ]
        };
    };
    UtilsModule.decorators = [
        { type: NgModule }
    ];
    /** @nocollapse */
    UtilsModule.ctorParameters = function () { return [
        { type: StaticInjectorService }
    ]; };
    return UtilsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AngularMaterialModule = /** @class */ (function () {
    function AngularMaterialModule() {
    }
    AngularMaterialModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        LayoutModule,
                        MatAutocompleteModule,
                        MatCheckboxModule,
                        MatDatepickerModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatRadioModule,
                        MatSelectModule,
                        MatSliderModule,
                        MatSlideToggleModule,
                        MatNativeDateModule,
                        // MatMomentDateModule,
                        MatMenuModule,
                        MatSidenavModule,
                        MatToolbarModule,
                        MatCardModule,
                        MatDividerModule,
                        MatExpansionModule,
                        MatGridListModule,
                        MatListModule,
                        MatStepperModule,
                        MatTabsModule,
                        MatTreeModule,
                        MatButtonModule,
                        MatButtonToggleModule,
                        MatBadgeModule,
                        MatChipsModule,
                        MatIconModule,
                        MatProgressSpinnerModule,
                        MatProgressBarModule,
                        MatBottomSheetModule,
                        MatDialogModule,
                        MatSnackBarModule,
                        MatTooltipModule,
                        MatPaginatorModule,
                        MatSortModule,
                        MatTableModule
                    ],
                    exports: [
                        LayoutModule,
                        MatAutocompleteModule,
                        MatCheckboxModule,
                        MatDatepickerModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatRadioModule,
                        MatSelectModule,
                        MatSliderModule,
                        MatSlideToggleModule,
                        MatMenuModule,
                        MatSidenavModule,
                        MatToolbarModule,
                        MatCardModule,
                        MatDividerModule,
                        MatExpansionModule,
                        MatGridListModule,
                        MatListModule,
                        MatStepperModule,
                        MatTabsModule,
                        MatTreeModule,
                        MatButtonModule,
                        MatButtonToggleModule,
                        MatBadgeModule,
                        MatChipsModule,
                        MatIconModule,
                        MatProgressSpinnerModule,
                        MatProgressBarModule,
                        MatBottomSheetModule,
                        MatDialogModule,
                        MatSnackBarModule,
                        MatTooltipModule,
                        MatPaginatorModule,
                        MatSortModule,
                        MatTableModule
                    ]
                },] }
    ];
    return AngularMaterialModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AngularMaterialModule, ConsoleLoggerService, LoggerService, StaticInjectorService, UtilsModule, UtilsConfigService as ɵa };
//# sourceMappingURL=utils.js.map
